import { apiSlice } from "./api";

const fields = [
  'id', 'name', 'description', 'meta',
].join(',');

export const atfStateApiSlice = apiSlice.injectEndpoints({
    endpoints: build => ({
      getStates: build.query({
        query: () => `atf_state/?per_page=100&_fields=${fields}`,
        providesTags: (result) =>
          result
            ? [
                ...result.map(({ id }) => ({ type: 'atf_state', id })),
                { type: 'atf_state', id: 'LIST' },
              ]
            : [{ type: 'atf_state', id: 'LIST' }],
      }),
      getState: build.query({
        query: (id) => {
            return `atf_state/${id}/?_fields=${fields}`
        },
        providesTags: (result, error, id) => [{ type: 'atf_state', id }],
      }),
    }),
    overrideExisting: true,
});

export const { 
    useGetStatesQuery,
    useGetStateQuery
} = atfStateApiSlice;
